import React, { useState } from 'react';
import './Sidebar.css';

// Icon map — gives every nav item a clean emoji icon
const ICON_MAP = {
  'ops-console':      '⚡',
  'client-workspace': '🏠',
  'home':             '📊',
  'manager':          '📞',
  'clients-mgmt':     '🏢',
  'onboarding':       '🚀',
  'overview':         '👁',
  'company':          '🏛',
  'portal':           '🗂',
  'unified-inbox':    '📥',
  'sales-chat':       '💬',
  'channels':         '📡',
  'whatsapp':         '💬',
  'facebook':         '📘',
  'instagram':        '📷',
  'email':            '📧',
  'campaigns':        '📢',
  'live-chat':        '🔴',
  'sales-dashboard':  '📈',
  'crm':              '👥',
  'client-lookup':    '🔍',
  'crm-sync':         '🔄',
  'bookings':         '📅',
  'calendar-sync':    '🗓',
  'payments':         '💳',
  'analytics':        '📉',
  'analytics-dashboard': '📊',
  'ai-insights':      '🧠',
  'financial':        '💰',
  'referrals':        '🔗',
  'callbacks':        '📲',
  'sentiment':        '🎭',
  'ab-testing':       '🧪',
  'knowledge-base':   '📚',
  'ai-test':          '🎙',
  'recordings':       '🎧',
  'ivr':              '☎',
  'ai-feedback':      '⭐',
  'support':          '🎧',
  'compliance':       '🛡',
  'business-context': '⚙️',
  'billing':          '📋',
  'tokens':           '🪙',
  'settings':         '⚙️',
  'admin-users':      '👤',
  'permissions':      '🔐',
  'team-manager':     '👥',
  'global-number-inventory': '📍',
  'tests':            '🔬',
  'social-channels':  '🌐',
  'pricing':               '💎',
  'my-ai-chat':            '🤖',
  'booking-settings':      '🕒',
  'projects-dashboard':    '📐',
  'projects-view':         '🗒',
  'project-detail-view':   '🗒',
  'tasks-view':            '✅',
  'milestones-view':       '🚩',
  'time-logging-view':     '⏱',
  'notifications':         '🔔',
  'onboarding-checklist':  '🚦',
  'billing-history':       '🧾',
  'system-health':         '💚',
  'data-capturer-dashboard': '📋',
  'twilio-setup':            '📱',
  'phone-number-setup':      '☎️',
  'phone-number-requests':   '📥',
};

const ROLE_LABEL_MAP = {
  developer: 'Developer',
  admin: 'Administrator',
  sales: 'Sales Rep',
  support: 'Support Agent',
  customer: 'Client',
  user: 'Client',
};

export default function Sidebar({
  currentView,
  setCurrentView,
  user,
  onLogout,
  navigation = [],
  sidebarOpen,
  onToggleSidebar,
  sidebarCollapsed,
  onToggleCollapse,
}) {
  const [collapsedSections, setCollapsedSections] = useState({});

  const displayName = user?.full_name || user?.email || 'User';
  const initial = displayName.charAt(0).toUpperCase();
  const role = user?.role || 'user';
  const roleLabel = ROLE_LABEL_MAP[role] || role;

  const toggleSection = (key) => {
    setCollapsedSections(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <aside className={`ds-sidebar${sidebarCollapsed ? ' ds-sidebar--collapsed' : ''}${!sidebarOpen ? ' ds-sidebar--hidden' : ''}`}>
      {/* Brand */}
      <div className="ds-sidebar__brand">
        <img src="/assets/oakdesk_logo.svg" alt="Oakdesk" className="ds-sidebar__logo" />
        <span className="ds-sidebar__wordmark">Oakdesk</span>
      </div>

      {/* Navigation */}
      <nav className="ds-sidebar__nav">
        {navigation.map((section) => (
          <div key={section.section} className="ds-nav-section">
            {!sidebarCollapsed && (
              <button
                className="ds-nav-section__toggle"
                onClick={() => toggleSection(section.section)}
              >
                <span className="ds-nav-section__label">{section.section}</span>
                <span className={`ds-nav-section__chevron${collapsedSections[section.section] ? ' ds-nav-section__chevron--closed' : ''}`}>›</span>
              </button>
            )}
            {!collapsedSections[section.section] && (
              <div className="ds-nav-section__items">
                {section.items.map((item) => (
                  <button
                    key={item.id}
                    className={`ds-nav-item${currentView === item.id ? ' ds-nav-item--active' : ''}`}
                    onClick={() => setCurrentView(item.id)}
                    title={sidebarCollapsed ? item.label : undefined}
                  >
                    <span className="ds-nav-item__icon">
                      {ICON_MAP[item.id] || item.icon || item.label.charAt(0)}
                    </span>
                    <span className="ds-nav-item__label">{item.label}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>

      {/* User footer */}
      <div className="ds-sidebar__footer">
        <div className="ds-user-row" onClick={() => setCurrentView('profile')} title="My profile" style={{ cursor: 'pointer' }}>
          <div className="ds-user-avatar">{initial}</div>
          <div className="ds-user-info">
            <div className="ds-user-name">{displayName}</div>
            <div className="ds-user-role">{roleLabel}</div>
          </div>
          <button
            className="ds-logout-btn"
            title="Log out"
            onClick={(e) => { e.stopPropagation(); onLogout(); }}
          >
            ⎋
          </button>
        </div>
      </div>

      {/* Collapse toggle */}
      <button className="ds-collapse-btn" onClick={onToggleCollapse} title={sidebarCollapsed ? 'Expand' : 'Collapse'}>
        {sidebarCollapsed ? '›' : '‹'}
      </button>
    </aside>
  );
}
